import React from 'react';
import './page-loader.css';

export default function PageLoader({ fullPage = false, label = 'Loading page...' }) {
  return <div className={`page-loader${fullPage ? ' page-loader-full' : ''}`} role="status" aria-label={label} aria-live="polite">
    <span className="page-loader-spinner" aria-hidden="true" />
  </div>;
}
